<template>
  <div class="load-more-data" :id="id" :class="{ 'd-none': !isLoading }">
    <div class="w-100 p-t-16 text-center">
      <div class="spinner-border text-secondary"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "loadData",
  props: {
    id: String,
    isLoading: Boolean,
    options: Array,
  },
  data() {
    return {
      observer: null,
    };
  },
  mounted() {
    const options = this.options || {};
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        this.$emit("intersect");
      }
    }, options);
    this.observer.observe(this.$el);
  },
  destroyed() {
    this.observer.disconnect();
  },
};
</script>
